(function() {  initializeUtilsFunctions();
  executeOnce('cta-fixed-filter-mobile', function () {
    function isScrolledIntoView(el) {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;

      // Only completely visible elements return true:
      let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
      // Partially visible elements return true:
      //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      if(el.classList.contains('fixed') && isVisible && window.scrollY <= 225) {
        el.classList.remove('fixed');
      } else if (!el.classList.contains('fixed') && !isVisible && window.scrollY > 225) {
        el.classList.add('fixed');
      };
    }

    const filterButton = document.querySelector('#cta-fixed-filter-mobile');

    window.addEventListener('scroll', () => {
      if(filterButton) {
        isScrolledIntoView(filterButton);
      }
    });

    if(filterButton) {
      isScrolledIntoView(filterButton);
    }
  });
}());
